import { render } from "./cover.vue?vue&type=template&id=35bb171f&scoped=true&ts=true"
import script from "./cover.vue?vue&type=script&lang=ts"
export * from "./cover.vue?vue&type=script&lang=ts"

import "./cover.vue?vue&type=style&index=0&id=35bb171f&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bb171f"]])

export default __exports__